import { TaskType } from "__graphql__/types";
import { PageName } from "analytics/events";

import { BaseChecksList } from "./BaseChecksList";

export function RecountChecksList() {
  return (
    <BaseChecksList
      taskType={TaskType.eoy_inventory_recount_check}
      pageOrigin={PageName.INVENTORY_RECOUNT_CHECK_LIST_PAGE}
      title="flows.inventory.recount-checks.pages.recount-checks-list.title"
    />
  );
}
